module.exports = __webpack_public_path__ + "img/71.d848bd8d.png";